import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import { SpinResult } from '../SlotResult';
import HistoryData from './HistoryData';

export default class LobbyHistoryData extends HistoryData {
    public readonly betType: number;
    public readonly hasJackpot: boolean;
    public readonly hasFeature: boolean;
    public readonly hasFreeGame: boolean;
    public readonly result: SpinResult;

    constructor(rawData: DataType.History.ResultData) {
        super(rawData);
        this.betType = rawData.BetType ?? 0;
        this.hasJackpot = rawData.HasJP ?? false;
        this.hasFeature = rawData.HasFeature ?? false;
        this.hasFreeGame = rawData.HasFree ?? false;

        this.result = new SpinResult({ Bet: this.bet, Win: this.win, Mul: 0, GameJP: this.hasJackpot, Free: this.hasFreeGame, Feature: this.hasFeature }, 0);
    }
}
